export default ".form-item{cursor:move}.form-item label{cursor:move}"